import { createContext, FC, useContext, useState } from "react";
import {
  useColorModeValue,
  Modal,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { InfinitySpin } from "react-loader-spinner";

import * as Types from "../api/types";

const LoadingContext = createContext<Types.LoadingContext | null>(null);

export const LoadingProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const brandColor = useColorModeValue("brand.500", "white");
  const [isLoaded, setLoad] = useState(false)
  const show = () => { onOpen(); setLoad(false) };
  const hide = () => { onClose(); setLoad(true) }
  return (
    <LoadingContext.Provider value={{ show, hide, isLoaded }}>
      <Modal isCentered isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent backgroundColor="transparent" boxShadow="none" w="200px">
          <InfinitySpin width="400" color={brandColor} />
        </ModalContent>
      </Modal>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  return useContext(LoadingContext);
};
